<template>
  <div>
    <CustomLoader v-if="isLoading" :width="70"></CustomLoader>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important" toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Transport Entry Form - {{ formData.enqNumber }}</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <b-row class=" mb-3">
              <b-col cols="12" md="3">
                <label class="mt-2 mr-3" for="jobType">Job Type *</label>

                <b-row>
                  <b-col v-for="(segmentNameArray, index) in showSegmentArray" :key="index"
                    :cols="segmentNameArray.flex" cols="12" class="flex">
                    <b-form-checkbox v-model="formData.jobType[index]" :value="segmentNameArray.value"
                      :name="'jobType' + (index + 1)" :id="'jobType' + (index + 1)" class="mr-2"
                      @change="jobTypeSelect(segmentNameArray.value, index)">
                      <b-badge variant="light">{{ segmentNameArray.show }}</b-badge>
                    </b-form-checkbox>
                    <span class="error" v-if="!formData.jobType[index]">{{ errorValidation.jobType }}</span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="3">
                <label for="enqNumber">Client Type:*</label>
                <model-list-select :isDisabled="true" @input="fetchType" :list="clientTypeList" id="clientNamenew"
                  v-model="formData.clientType" option-value="val" option-text="type"
                  placeholder="Client Type"></model-list-select>
                <span class="error" v-if="!formData.clientType">{{ errorValidation.clientType }}</span>
              </b-col>
              <b-col cols="12" md="3">
                <label for="enqNumber">Shipping Type:*</label>
                <model-list-select :isDisabled="true" @input="getDataLocations" :list="shipmentTypeList"
                  v-model="formData.shipmentType" option-value="shipmentTypeVal" option-text="shipmentTypeText"
                  placeholder="Select Shipment Type"></model-list-select>
                <span class="error" v-if="!formData.shipmentType">{{ errorValidation.shipmentType }}</span>
              </b-col>
              <b-col cols="12" md="3">
                <label for="enqNumber">Transport Type:*</label>
                <model-list-select :isDisabled="true" :list="transportTypeList" v-model="formData.transportType"
                  option-value="transportTypeVal" option-text="transportTypeText"
                  placeholder="Select"></model-list-select>
                <span class="error" v-if="!formData.transportType">{{ errorValidation.transportType }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.mainEnquiryId">
                <label for="enqNumber">ENQ Number:*</label>
                <b-form-input :formatter="capitalizeAll" id="enqNumber" name="enqNumber" v-model="formData.enqNumber" />
                <span class="error" v-if="!formData.enqNumber">{{ errorValidation.enqNumber }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.clientType == '2'">
                <label for="lead_comp_name">Lead Name:*</label>
                <model-list-select class="ml-1" :list="$store.getters['common/getAllLeadCompList']" id="newClientName"
                  v-model="formData.newClientName" option-value="lead_comp_name" option-text="lead_comp_name"
                  placeholder="Select Lead Name" @input="LeadClientDetails()"></model-list-select>
                <span class="error" v-if="!formData.newClientName">{{ errorValidation.newClientName }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.clientType == '2'">
                <label for="newClientEmail">Client Email:*</label>
                <b-form-input :formatter="capitalizeAll" id="newClientEmail" name="newClientEmail"
                  v-model="formData.newClientEmail" />
                <span class="error" v-if="!formData.newClientEmail">{{ errorValidation.newClientEmail }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.clientType == '2'">
                <label for="newClientPhoneNumber">Contact No. *</label>
                <b-form-input :formatter="capitalizeAll" id="newClientPhoneNumber" name="newClientPhoneNumber"
                  type="text" v-model="formData.newClientPhoneNumber" />
                <span class="error"
                  v-if="!formData.newClientPhoneNumber">{{ errorValidation.newClientPhoneNumber }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.clientType == '2'">
                <label for="newClientAddress">Client Address *</label>
                <b-textarea id="newClientAddress" name="newClientAddress" type="number"
                  v-model="formData.newClientAddress"></b-textarea>
                <span class="error" v-if="!formData.newClientAddress">{{ errorValidation.newClientAddress }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.clientType != '2'">
                <label for="clientId">Client:*</label>
                <model-list-select :isDisabled="formData.shipmentType == '' ||
                  formData.transportType == ''
                  " :list="$store.getters['common/getAllClientList']" id="clientfilter" v-model="formData.clientId"
                  option-value="clientId" option-text="clientName" placeholder="Select Client Name"
                  @input="getClientFactoryLoc"></model-list-select>
                <span class="error" v-if="!formData.clientId">{{ errorValidation.clientId }}</span>
              </b-col>

              <b-col cols="12" md="3" v-if="formData.clientId && !formData.mainEnquiryId">
                <label for="newClientAddress">Client Email & State:*</label>
                <b-textarea id="newClientAddress" name="newClientAddress" type="text"
                  v-model="clientIntro"></b-textarea>

              </b-col>
              <b-col cols="12" md="3">
                <label for="from_loc">From:*</label>
                <model-list-select :isDisabled="!formData.clientId"
                  :list="$store.getters['commonDropdownMaster/getAllStuffingList']" v-model="formData.from_loc"
                  option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select From Location"></model-list-select>
                <span class="error" v-if="!formData.from_loc">{{ errorValidation.from_loc }}</span>
              </b-col>
              <b-col cols="12" md="3">
                <label for="to_loc">To:*</label>
                <model-list-select :isDisabled="!formData.clientId"
                  :list="$store.getters['commonDropdownMaster/getAllStuffingList']" v-model="formData.to_loc"
                  option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select To Location"></model-list-select>
                <span class="error" v-if="!formData.to_loc">{{ errorValidation.to_loc }}</span>
              </b-col>

              <b-col cols="12" md="3">
                <label for="commodityType">Container Type *</label>
                <model-list-select
                    :isDisabled="
                      (formData.shipmentType == '1' &&
                      formData.multipleContainerType[0] == 'LCL Container')
                        ? true
                        : false
                    "
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="AutoContainerType"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>

                  <span
                  md-flex="70"
                  md-flex-small="100"
                  v-if="formData.multipleContainerType.length > 0"
                >
                  <md-chip
                    style="margin-top: 38px"
                    md-deletable
                    v-for="(type, index) in formData.multipleContainerType"
                    :key="index"
                    @delete="deleteContainer(type)"
                    >{{ type }}</md-chip
                  >
              </span>
              <span class="error" v-if="formData.multipleContainerType.length<=0">{{ errorValidation.multipleContainerType }}</span>
              </b-col>

              <b-col cols="12" md="3">
                <label for="commodityType">Commodity Type:*</label>
                <model-list-select :list="commodityTypeName" v-model="formData.commodityType"
                  option-value="commodityTypeVal" option-text="commodityTypeText"
                  placeholder="Select Commodity Type"></model-list-select>
                <span class="error" v-if="!formData.commodityType">{{ errorValidation.commodityType }}</span>
              </b-col>

              <b-col cols="12" md="3" v-if="formData.commodityType == 'Hazardous'">
                <label for="IMDGClass">IMDG Class</label>
                <b-form-input :formatter="capitalizeAll" id="IMDGClass" name="IMDGClass" v-model="formData.IMDGClass" />
                <span class="error" v-if="!formData.IMDGClass">{{ errorValidation.IMDGClass }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.commodityType == 'Hazardous'">
                <label for="UNNumber">UN Number</label>
                <b-form-input :formatter="capitalizeAll" id="UNNumber" name="UNNumber" v-model="formData.UNNumber" />
                <span class="error" v-if="!formData.UNNumber">{{ errorValidation.UNNumber }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.commodityType == 'Hazardous'">
                <label for="packingCode">Packing Code</label>
                <b-form-input :formatter="capitalizeAll" id="packingCode" name="packingCode"
                  v-model="formData.packingCode" />
                <span class="error" v-if="!formData.packingCode">{{ errorValidation.packingCode }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.commodityType == 'Reefer'">
                <label>Temperature Req(Degree Celsius)</label>
                <b-form-input :formatter="capitalizeAll" id="temperatureRequired" name="temperatureRequired"
                  v-model="formData.temperatureRequired" />
                <span class="error" v-if="!formData.temperatureRequired">{{ errorValidation.temperatureRequired }}</span>
              </b-col>
              <b-col cols="12" md="3" v-if="formData.commodityType == 'Others'">
                <label>Specific Detail if any..!</label>
                <b-form-input :formatter="capitalizeAll" id="otherComodity" name="otherComodity"
                  v-model="formData.otherComodity" />
                <span class="error" v-if="!formData.otherComodity">{{ errorValidation.otherComodity }}</span>
              </b-col>

              <b-col cols="12" md="3">
                <label for="tptType">TPT Type</label>
                <model-list-select :list="cctypeList" v-model="formData.tptType" option-value="ccTypeVal"
                  option-text="ccTypeTxt" placeholder="Select"></model-list-select>
                <span class="error" v-if="!formData.tptType">{{ errorValidation.tptType }}</span>
              </b-col>
              <b-col cols="12" md="3">
                <label>ON ACCOUNT OF</label>
                <b-form-input :formatter="capitalizeAll" id="onAccountOf" name="onAccountOf"
                  v-model="formData.onAccountOf" />
                <span class="error" v-if="!formData.onAccountOf">{{ errorValidation.onAccountOf }}</span>
              </b-col>

              <b-col cols="12" md="12" v-if="allModuleIdNew == '' || allModuleIdNew == null"
                class="justify-content-center mt-3">
                <b-button variant="primary" id="addButtonLoader" @click="onCloseSubmit">Save & Submit</b-button>
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
                <!-- <b-button
                  v-if="showQuoteButton == true"
                  size="sm"
                  variant="warning"
                  @click="showExistQuote"
                  >Show Existing Quotes</b-button
                > -->
              </b-col>

            </b-row>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop22"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" @close="onCloseAddFF"
      ref="addPop"></md-dialog-alert>
    <md-snackbar :md-position="vertical + ' ' + horizontal" ref="snackbar" :md-duration="duration">
      <span>{{ snackbarData }}</span>
    </md-snackbar>
    <md-dialog-confirm :md-title="confirm.title" :md-content-html="confirm.contentHtml" :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel" @close="onCloseSubmit" ref="dialog5"></md-dialog-confirm>
  </div>
</template>


<script>
import axios from "axios";
import CustomLoader from "../common/customLoader.vue";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";
export default {
  beforeMount() {

    this.$store.dispatch(
      "common/setAllLeadCompList",
      JSON.stringify({
        itemCode: "GET_LeadCompLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllStuffingDDList",
      JSON.stringify({
        itemCode: "AllStuffingList",
      })
    );
    if (this.$sessionsStorage.get("userId") == "133") {
      this.$router.push({
        path: "/dashboard",
      });
    }
    this.$store.dispatch(
      "common/setAllLeadCompList",
      JSON.stringify({
        itemCode: "GET_LeadCompLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/mainEnquiry/transportEnq");
      this.getServicesData();
      // this.getData();
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    AutoContainerType: {
      handler: function (newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true,
    },
  },
  data() {
    return {
      allModuleIdNew:
        this.$sessionsStorage.get("editallModuleId") != "" ||
          this.$sessionsStorage.get("editallModuleId") != undefined
          ? this.$sessionsStorage.get("editallModuleId")
          : "",
      newJobType: ["TPT"],
      showQuoteButton: false,
      confirm: {
        title: "CONFIRMATION",
        contentHtml:
          " <strong>Data cannot be updated onces submitted.</strong><br> Are you sure to proceed ?",
        ok: "Save & Submit",
        cancel: "Cancel ",
      },
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
            this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      vertical: "bottom",
      horizontal: "center",
      duration: 1700,
      snackbarData: "",
      flavours: ["Orange", "Grape", "Apple", "Lime", "Very Berry"],
      windowSize: "",
      clientIntro: "",
      selectDateFormat,
      showSegmentArray: [],
      getCommodityData: [],
      getContainerTypeData: [],
      getlocationListData: [],
      getAlllocationListData: [],
      handoverListData: [],
      getAlllocationListDataFactory: [],
      tempFactoryData: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],
      AirIcdPOrtList: [],

      finalAllPlaceData: [],
      airLineList: [],
      getColoaderNameList: [],

      showFFCCAccordina: false,
      showTPTAccordian: false,
      isLoading: false,
      clientIntro: "",
      formData: {
        jobType: ["TPT"],
        clientType: '1',
        transportType: 'Domestic',
        shipmentType: '1',
        mainEnquiryId: "",
        enqDate: "",
        enqNumber: this.generateEnqNumber(),
        tptType: "",
        tptClientStatus: "",
        allModuleId: "",
        from_loc: '',
        to_loc: '',
        multipleContainerType:[],
        multipleContainerTypeId:[],
        clientId: "",
        exporterClientId: "",
        importerClientId: "",
        commodityId: "",
        newClientName: "",
        commodityType: "",
        IMDGClass: "",
        otherComodity: "",
        itemDescription: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        remark: "",
        fk_lead_id: "",
        newClientName: "",
        newClientEmail: "",
        newClientAddress: "",
        newClientPhoneNumber: "",
        selectedFFQuotationId: "",
        selectedTPTQuotationId: "",
        selectedCCQuotationId: "",
        onAccountOf: "",
        ffClientStatus: "",
        tptEnquiry: [],
        airlineId: "",
        ffShippingWiseId: "",
        enqIdTPT: "",
        tptType: "",
        tptClientStatus: "",
      },

      // CUstom Validation Variable Declaration Start 23/06/2023
      errorValidation: {
        jobType: "",
        clientType: "",
        shipmentType: "",
        transportType: "",
        clientId: "",
        from_loc: "",
        to_loc: "",
        multipleContainerType:"",
        commodityType: "",
      },

      arrayerrorValidation: [
        {
          jobType: "Select Job Type ",
          clientType: "Select Client Type",
          shipmentType: "Select Shipment Type",
          transportType: "Select Transport Type",
          clientId: "Select Client",
          from_loc: "Select From Location",
          to_loc: "Select To Location",
          multipleContainerType: "Select Container Type",
          commodityType: "Select Comodity Type",
        },
      ],
      validate: true,
      // CUstom Validation Variable Declaration End 23/06/2023
      oldTransport: "",
      oldShipment: "",
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      cctypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
        {
          ccTypeVal: "3",
          ccTypeTxt: "Not Applicable",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      transportTypeList: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
        {
          transportTypeVal: "Domestic",
          transportTypeText: "Domestic",
        },
      ],
      clientTypeList: [
        {
          type: "Client",
          val: "1",
        },
        {
          type: "Lead",
          val: "2",
        },
        {
          type: "Overseas Agent",
          val: "3",
        },
      ],
      getCLientData: [],
      tempfactoryDetail: [],
      AutoContainerType: {},
    };
  },

  mounted() { },
  beforeDestroy() { },
  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {},
  methods: {
    deleteContainer(item) {
      let i = this.formData.multipleContainerType.indexOf(item);

      this.formData.multipleContainerType.splice(i, 1);
      this.formData.multipleContainerTypeId.splice(i, 1);
    },
    masterCallbackContainer(item) {
      if (this.formData.multipleContainerType.length > 0) {
        let i = this.formData.multipleContainerType.indexOf(item.containerType);

        if (i < 0) {
          this.formData.multipleContainerType.push(item.containerType);
          this.formData.multipleContainerTypeId.push(item.containerTypeId);
        }
      } else {
        this.formData.multipleContainerType.push(item.containerType);
        this.formData.multipleContainerTypeId.push(item.containerTypeId);
      }
      if (this.formData.multipleContainerType.length > 0) {
        this.FactoryContainerType();
      }
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },

    onCloseSubmit(type) {
      this.$refs["dialog5"].open();
      if (type == "ok") {
        this.addFFExport();
      }
    },
    validateFFExport() {
      let validate_new = true;
      Object.keys(this.errorValidation).map((x, index) => {
        if (
          this.formData[x] == "" ||
          this.formData[x] == 0 ||
          this.formData[x] == undefined ||
          this.formData[x] == null ||
          this.formData[x] == "undefined" ||
          this.formData[x] == "null"
        ) {
          this.errorValidation[x] = this.arrayerrorValidation[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addFFExport() {
      this.hideQuoteMode = true;

      this.validateFFExport();
      console.log("this.errorValidation=>", this.errorValidation)
      console.log("this.errorValidation validate=>", this.validate)
      if (
        this.newJobType.indexOf("TPT") < 0 &&
        this.formData.selectedTPTQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing TPT Quotation";
        this.$refs["addPop22"].open();
        return false;
      }

      if (this.newJobType.length == 0) {
        this.alert.content = "Please select atleast one job type";
        this.$refs["addPop22"].open();
        return false;
      }

      // if (this.formData.ffClientStatus == "1") {
      //   if (this.formData.ffShippingWiseId == "") {
      //     this.alert.content = "Please select Shipping Line Approved By Client";
      //     this.$refs["addPop22"].open();
      //     return false;
      //   }
      // }

      if (this.validate == true) {
        let newVal = [];

        this.showSegmentArray.map((x, index) => {
          if (this.formData.jobType[index] == true) {
            newVal.push(x.value);
          }
        });

        this.formData["jobType"] = newVal;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainEnquiry.php`,
          data: JSON.stringify(this.formData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");
              if (this.formData.mainEnquiryId == "") {
                this.snackbarData = "Data Added Successfully";
              } else {
                this.snackbarData = "Data Updated Successfully";
              }
              this.hideQuoteMode = false;
              this.$refs.snackbar.open();
              this.$router.push({
                path: "/viewMainEnquiryDetails/viewMainEnquiryDetails",
              });
            }
          })
          .catch((error) => { });
      }
    },
    onCloseAddFF() {
      this.$router.push({
        path: "/viewMainEnquiryDetails/viewMainEnquiryDetails",
      });
    },
    LeadClientDetails() {
      let values = this.$store.getters["common/getAllLeadCompList"].filter((x) => {
        return x.lead_comp_name == this.formData.newClientName;
      });
      console.log("values=>", values);
      if (values.length > 0) {
        this.formData.fk_lead_id = values[0].lead_id;
        this.formData.exporterClientId = values[0].lead_id;
        if (
          values[0].lead_details != null &&
          values[0].lead_details != undefined &&
          values[0].lead_details != ""
        ) {
          let lead_details = JSON.parse(values[0].lead_details);
          console.log(lead_details);

          this.formData.newClientEmail = "";
          this.formData.newClientPhoneNumber = "";
          lead_details.forEach((element) => {
            if (this.formData.newClientEmail) {
              this.formData.newClientEmail =
                this.formData.newClientEmail + "," + element.lead_email;
            } else {
              this.formData.newClientEmail = element.lead_email;
            }

            if (this.formData.newClientPhoneNumber) {
              this.formData.newClientPhoneNumber =
                this.formData.newClientPhoneNumber + "," + element.lead_mobile;
            } else {
              this.formData.newClientPhoneNumber = element.lead_mobile;
            }
          });
        }
        let newClientPhoneNumber = this.formData.newClientPhoneNumber
          .replace(/ /g, "")
          .split(",");
        console.log("newClientPhoneNumber", newClientPhoneNumber);
        newClientPhoneNumber = [...new Set(newClientPhoneNumber)];
        console.log("newClientPhoneNumber", newClientPhoneNumber);
        this.formData.newClientPhoneNumber = "";
        this.formData.newClientPhoneNumber = newClientPhoneNumber.join(",");
        this.formData.newClientAddress = values[0].lead_address;
      }
      console.log("this.formData=>", this.formData);
    },
    getDataLocations() {
      if (
        this.formData.shipmentType != "" &&
        this.formData.transportType != "" &&
        this.oldTransport != this.formData.transportType &&
        this.oldShipment != this.formData.transportType
      ) {
        this.oldTransport = this.formData.transportType;
        this.oldShipment = this.formData.shipmentType;
        let vehicle_drive = {
          shipmentType: this.formData.shipmentType,
          transportType: this.formData.transportType,
          clientType: this.formData.clientType,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/getDataEnquiryLocations.php`,
          data: JSON.stringify(vehicle_drive),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.LocationDetailsTransport.length > 0) {
                this.getAlllocationListData = data.LocationDetailsTransport;
                this.handoverListData = data.LocationDetailsTransport;
              }
              if (data.LocationDetailsIcdIndiaSea.length > 0) {
                this.IcdPOrtList = data.LocationDetailsIcdIndiaSea;
              }

              if (data.LocationDetailsIndiaSea.length > 0) {
                this.PortLoadList = data.LocationDetailsIndiaSea;
              }

              if (data.LocationDetailsSeaPortsNotIndia.length > 0) {
                this.getPortDischargeList = data.LocationDetailsSeaPortsNotIndia;
                this.finalAllPlaceData = data.LocationDetailsSeaPortsNotIndia;
              }

              if (data.LocationDetailsClientFac.length > 0) {
                this.tempFactoryData = data.LocationDetailsClientFac;
                this.getAlllocationListDataFactory = data.LocationDetailsClientFac;
              }
              if (data.LocationDetailsAirPorts.length > 0) {
                this.AirPortLoadList = data.LocationDetailsAirPorts;
                this.AirIcdPOrtList = data.LocationDetailsAirPorts;
              }
            }
          })
          .catch((error) => { });
      }
    },

    getData() {
      let array = [];
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
            this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getDataMainEnqTest.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
            if (data.LocationDetailsFinal.length > 0) {
              this.getAlllocationListData = data.LocationDetailsFinal;
              this.handoverListData = data.LocationDetailsFinal;
              this.IcdPOrtList = data.LocationDetailsFinal;
              this.getPortDischargeList = data.LocationDetailsFinal;
              this.finalAllPlaceData = data.LocationDetailsFinal;
              this.PortLoadList = data.LocationDetailsFinal;
              this.getAlllocationListDataFactory = data.LocationDetailsFinal;
              this.AirPortLoadList = data.LocationDetailsFinal;
              this.AirIcdPOrtList = data.LocationDetailsFinal;
            }

            if (data.ClientfactoryDetail.length > 0) {
              this.tempfactoryDetail = data.ClientfactoryDetail;
            }
            if (data.UserData.length > 0) {
              this.formData.BranchCode = data.UserData[0].BranchCode;
            }

            if (data.airLineList.length > 0) {
              this.airLineList = data.airLineList;
            }
            if (data.coloaderData.length > 0) {
              this.getColoaderNameList = data.coloaderData;
            }

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetailImpExp;
              this.allClientAndOverSea = data.clientdetail;
            } else {
              this.getCLientData = [];
            }
            if (data.clientdetailImpExp.length > 0) {
              this.getImporterExpo = data.clientdetailImpExp;
            } else {
              this.getImporterExpo = [];
            }

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            } else {
              this.getShippingLineData = [];
            }

            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            } else {
              this.getContainerTypeData = [];
            }

            if (data.tptEnquiry.length > 0) {
              this.formData.tptEnquiry = data.tptEnquiry;
            }
            if (data.ccEnquiry.length > 0) {
              this.formData.ccEnquiry = data.ccEnquiry;
            }

            if (data.ffShippingArray.length > 0) {
              this.ffShippingArray = data.ffShippingArray;
            }

            if (data.ffEnquiry.length > 0) {
              this.formData.ffEnquiry = data.ffEnquiry;
            }

            if (data.editAssignmentData.length > 0) {
              this.EnqNo = data.editAssignmentData[0].mainEnquirySeries;
              Object.keys(data.editAssignmentData[0]).map((x) => {
                if (x == "jobType") {
                  array = data.editAssignmentData[0][x].split(",");
                  this.newJobType = data.editAssignmentData[0][x].split(",");
                } else {
                  this.formData[x] = data.editAssignmentData[0][x] || "";
                }
              });

              if (this.formData["tptStatus"] == "1") {
                this.formData["tptClientStatus"] = "1";
              }

              if (this.formData["ffStatus"] == "1") {
                this.formData["ffClientStatus"] = "1";
                let array = this.ffShippingArray.filter((x) => {
                  return x.ffClientStatus == "1";
                });
                if (array.length > 0) {
                  this.formData.ffShippingWiseId = array[0].ffShippingWiseId;
                }
              }

              this.formData["jobType"] = ["TPT"];

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.formData.jobType[index] = true)
                  : (this.formData.jobType[index] = false);
              });

            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }

            this.isLoading = false;
            this.$refs["confirm"].show();
          }
        })
        .catch((error) => { });
    },
    getClientFactoryLoc() {
      if (this.formData.clientId != "") {
        this.$store.dispatch(
          "commonDropdownMaster/setAllStuffingDDList",
          JSON.stringify({
            itemCode: "AllStuffingList",
            clientId: this.formData.clientId,
          })
        );
        let clientInt = this.$store.getters['common/getAllClientList'].filter((y) => {
          return y.clientId == this.formData.clientId;
        });
        if (clientInt.length > 0) {
          console.log("clientInt=>", clientInt); //companyType
          this.clientIntro =
            "Email : " +
            clientInt[0].email +
            "   Company Type : " +
            clientInt[0].companyType +
            "   State : " +
            clientInt[0].stateName;
        }

      }
    },
    fetchType() {
      this.transportTypeList = [];
      if (this.formData.clientType == "3") {
        let overSeaArry = this.allClientAndOverSea.filter((x) => {
          return x.agentColoderId > 0;
          // return x.agentColoderId != "0";
        });
        if (overSeaArry.length > 0) {
          this.getCLientData = overSeaArry;
        }
        this.transportTypeList = [];
        let Arry = [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export",
          },
        ];
        this.transportTypeList = Arry;

      } else if (this.formData.clientType == "1") {
        let cArry = this.allClientAndOverSea.filter((x) => {
          return x.clientType == "Client";
        });
        if (cArry.length > 0) {
          this.getCLientData = cArry;
        }
        this.transportTypeList = [];
        let Arry = [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export",
          },
          {
            transportTypeVal: "Import",
            transportTypeText: "Import",
          },
          {
            transportTypeVal: "Domestic",
            transportTypeText: "Domestic",
          },
        ];
        this.transportTypeList = Arry;
      } else {
        this.transportTypeList = [];
        let Arry = [
          {
            transportTypeVal: "Export",
            transportTypeText: "Export",
          },
          {
            transportTypeVal: "Import",
            transportTypeText: "Import",
          },
          {
            transportTypeVal: "Domestic",
            transportTypeText: "Domestic",
          },
        ];
        this.transportTypeList = Arry;
      }
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "TPT",
          show: "TRANSPORTATION (TPT)",
          flex: "25",
        },
      ];
    },

    jobTypeSelect(value, index) {
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
        if (value == "TPT") {
          this.showTPTAccordian = false;
        } else {
          this.showFFCCAccordina = false;
        }
      } else {
        this.newJobType.push(value);
        if (value == "TPT") {
          this.showTPTAccordian = true;
        } else {
          this.showFFCCAccordina = true;
        }
      }

      if (
        this.newJobType.indexOf("TPT") < 0 &&
        this.formData.selectedTPTQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing TPT Quotation";
        this.$refs["addPop22"].open();
      }
      if (
        this.newJobType.indexOf("CC") < 0 &&
        this.formData.selectedCCQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing CC Quotation";
        this.$refs["addPop22"].open();
      }
      if (
        this.newJobType.indexOf("FF") < 0 &&
        this.formData.selectedFFQuotationId != ""
      ) {
        this.alert.content = "Please Remove Selected Existing FF Quotation";
        this.$refs["addPop22"].open();
      }
    },

    generateEnqNumber() {
      const branch = "XYZ";  // Replace with dynamic branch logic if needed
      const no = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
      return `ENQ/${branch}/DOM/${no}`;
    },
    submitForm() {
      alert('Form submitted!');
      console.log(this.formData);
      // Integration with Excel and Billing Excel would be done server-side
    }
  }
};
</script>

<style scoped>
form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

button {
  padding: 10px;
  background: #007BFF;
  color: white;
  border: none;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// transportEnq.vue?60ed1736